var render = function render(){var _vm=this,_c=_vm._self._c;return _c('button',{staticClass:"filter-button",class:_vm.additionalCssClasses},[(_vm.number)?_c('span',{staticClass:"filter-button__number"},[_vm._v(_vm._s(_vm.number))]):_vm._e(),_vm._v("\n    "+_vm._s(_vm.label)+"\n    "),_c('base-material-design-icon',{staticClass:"filter-button__icon",attrs:{"icon":"arrowDown"}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }